/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './css/HotelButtonsLoader.css';

function HotelButtonsLoader() {
  return (
    <div className="hbl_w">
      <div className="hbl_item">
        <Skeleton width="160px" height="56px" borderRadius="16px" />
      </div>
      <div className="hbl_item">
        <Skeleton width="130px" height="56px" borderRadius="16px" />
      </div>
      <div className="hbl_item">
        <Skeleton width="130px" height="56px" borderRadius="16px" />
      </div>
    </div>
  );
}

export default HotelButtonsLoader;
